import { resourceActions } from '../../services';

export const resourceDispatcher = dispatch => ( { 
  getLanguage: language => dispatch( { type: resourceActions.GET, language } )
} );
